import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const AiIcon = {
  name: 'AiIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 500 500",
        fill: "currentColor",
        "stroke-width": "0px"
      },
      "class": "feather feather-ai-logo"
    }, ctx.data]), [
      // Decorative elements group
      h("g", {}, [
        h("path", {
          attrs: {
            d: "M378.29,101.76c0.51,12.26,10.77,21.83,23.03,21.5l0,0l-1.2,0.03c-11.78,0.32-21.31,9.68-21.83,21.46l-0.07,1.61v-0.65c0-12.4-10.05-22.45-22.45-22.45h-0.65h0.65c12.4,0,22.45-10.05,22.45-22.45v-0.65L378.29,101.76z"
          }
        }),
        h("path", {
          attrs: {
            d: "M427.64,129.36c1.09,26.15,22.97,46.58,49.13,45.87h0l-2.57,0.07c-25.12,0.67-45.45,20.66-46.56,45.77l-0.15,3.44v-1.39c0-26.45-21.44-47.89-47.89-47.89h-1.39h1.39c26.45,0,47.89-21.44,47.89-47.89v-1.39L427.64,129.36z"
          }
        }),
        h("path", {
          attrs: {
            d: "M333.42,128.98c1.84,43.92,38.59,78.24,82.53,77.05h0l-4.31,0.12c-42.2,1.13-76.35,34.7-78.2,76.88l-0.25,5.78v-2.33c0-44.43-36.02-80.44-80.44-80.44h-2.33h2.33c44.43,0,80.44-36.02,80.44-80.44v-2.33L333.42,128.98z"
          }
        })
      ]),
      // Letters group
      h("g", {}, [
        h("path", {
          attrs: {
            d: "M158.76,150.72h-42.57l-79.2,208.42h46.44l16.39-45.55h75.32l16.37,45.55h46.45L158.76,150.72z M113.21,276.06l24.41-67.59l24.11,67.59H113.21z"
          }
        }),
        h("path", {
          attrs: {
            d: "M256.42,211.27v147.86h44.96V229.06C289.13,218.66,273.51,212.1,256.42,211.27z M256.42,150.72v50.08c17.09-0.83,32.71-7.39,44.96-17.79v-32.29H256.42z"
          }
        })
      ])
    ]);
  }
};

export default AiIcon;